<template>
    <div class="table-responsive">
        <table class="table-bordered table">
            <colgroup>
                <template v-for="(col, i) in CONFIG_TABLE_TAB_7().headers">
                    <col v-for="n in col.colspan || 1" :key="i + '-' + n" :style="{ width: col.width }" />
                </template>
            </colgroup>
            <tbody>
                <tr>
                    <th :colspan="lengthHeaders">＜抽選条件＞※応募割れの場合は抽選条件が変わる可能性があります。</th>
                </tr>
                <template v-if="SWITCH_FIELD_TAB_7(dataObject.prizes, isPreview)['賞品']">
                    <tr>
                        <template v-for="(objHeader, idx) in CONFIG_TABLE_TAB_7().headers">
                            <th
                                v-if="idx == 0"
                                :key="idx"
                                :rowspan="dataObject.prizes.data.length + 1"
                                :class="objHeader.bgClass"
                                style="padding-left: 3px"
                            >
                                <div class="d-flex flex-wrap align-items-center">
                                    <b-form-checkbox
                                        v-if="!isPreview && !isRolePartner"
                                        switch
                                        v-model="SWITCH_FIELD_TAB_7(dataObject.prizes)['賞品']"
                                        @change="toggleCommonSwitch($event, dataObject.prizes.data)"
                                    />
                                    <div>{{ objHeader.label }}</div>
                                </div>
                            </th>
                            <th v-else :key="idx" :class="objHeader.bgClass" :colspan="objHeader.colspan">{{ objHeader.label }}</th>
                        </template>
                    </tr>
                    <tr v-for="(item, k) in dataObject.prizes.data" :key="item.name">
                        <td class="bg-color5">{{ item.name }}</td>
                        <td>
                            <InputText
                                :model.sync="dataObject.prizes.data[k].number_of_win_prize"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_7(dataObject.prizes)['賞品']"
                                :config="inputConfig.num"
                                @change="
                                    (val) => {
                                        if (!val?.length) dataObject.prizes.data[k].number_of_win_prize = '0';
                                    }
                                "
                            />
                        </td>
                        <td>
                            <InputText
                                :model.sync="dataObject.prizes.data[k].preliminary_winner"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_7(dataObject.prizes)['賞品']"
                                :config="inputConfig.num"
                                @change="
                                    (val) => {
                                        if (!val?.length) dataObject.prizes.data[k].preliminary_winner = '0';
                                    }
                                "
                            />
                        </td>
                        <td>
                            <TextareaComponent
                                :id="'tab7-textarea-prizes-' + k"
                                :model.sync="item.write_freely"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_7(dataObject.prizes)['賞品']"
                                :isPreview="isPreview"
                                :config="inputConfig.write_freely"
                            />
                        </td>
                        <td>
                            <div
                                :class="`d-flex align-items-center justify-content-center box--text__disabled ${isNotCheckBoxPartner || isDisabled || !SWITCH_FIELD_TAB_7(dataObject.prizes)['賞品'] ? 'disabled_input' : ''}`"
                                :style="{
                                    'background-color':
                                        isNotCheckBoxPartner || isDisabled || !SWITCH_FIELD_TAB_7(dataObject.prizes)['賞品'] ? '' : '#ffffff'
                                }"
                            >
                                {{ item.total_winner }}
                            </div>
                        </td>
                        <td v-if="k == 0" :rowspan="dataObject.prizes.data.length" align="middle">
                            <div
                                :class="`d-flex align-items-center justify-content-center box--text__disabled ${isNotCheckBoxPartner || isDisabled || !SWITCH_FIELD_TAB_7(dataObject.prizes)['賞品'] ? 'disabled_input' : ''}`"
                                :style="{
                                    'background-color':
                                        isNotCheckBoxPartner || isDisabled || !SWITCH_FIELD_TAB_7(dataObject.prizes)['賞品'] ? '' : '#ffffff'
                                }"
                            >
                                {{ dataObject.prizes.sum_total_winner }}
                            </div>
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields[`prizes_${k}_first`])"
                                v-model="item.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('prizes', 'first', k)"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields[`prizes_${k}_secondary`])"
                                v-model="item.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('prizes', 'secondary', k)"
                            />
                        </td>
                    </tr>
                </template>

                <tr v-if="SWITCH_FIELD_TAB_7(dataObject, isPreview)['対象データ']">
                    <td class="bg-color5" colspan="2">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_7(dataObject)['対象データ']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        target_file: dataObject.target_file
                                    })
                                "
                            />
                            対象データ
                        </div>
                    </td>
                    <td colspan="5">
                        <CommonMultiselect
                            v-model="dataObject.target_file.data"
                            :options.sync="option.target_file"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_7(dataObject)['対象データ']"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.target_file_first)"
                            v-model="dataObject.target_file.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('target_file', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.target_file_secondary)"
                            v-model="dataObject.target_file.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('target_file', 'secondary')"
                        />
                    </td>
                </tr>
                <template v-if="SWITCH_FIELD_TAB_7(dataObject, isPreview)['■期間条件']">
                    <tr>
                        <td
                            class="bg-color5"
                            :rowspan="calculateRowspan(SWITCH_FIELD_TAB_7(dataObject, isPreview), CONFIG_ROWSPAN_TAB_7['■期間条件'])"
                        >
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_7(dataObject)['■期間条件']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            period_conditions_lottery: dataObject.period_conditions_lottery,
                                            period_conditions_postcard: dataObject.period_conditions_postcard
                                        })
                                    "
                                />
                                ■期間条件
                            </div>
                        </td>
                        <template v-if="SWITCH_FIELD_TAB_7(dataObject, isPreview)['抽選対象期間']">
                            <td class="bg-color5">
                                <div class="d-flex flex-wrap align-items-center">
                                    <b-form-checkbox
                                        v-if="!isPreview && !isRolePartner"
                                        switch
                                        v-model="SWITCH_FIELD_TAB_7(dataObject)['抽選対象期間']"
                                        :disabled="!SWITCH_FIELD_TAB_7(dataObject)['■期間条件']"
                                        @change="
                                            toggleCommonSwitch($event, {
                                                period_conditions_lottery: dataObject.period_conditions_lottery
                                            })
                                        "
                                    />
                                    抽選対象期間
                                </div>
                            </td>
                            <td colspan="5">
                                <div
                                    :class="`box--text__disabled ${isNotCheckBoxPartner || isDisabled || !SWITCH_FIELD_TAB_7(dataObject)['抽選対象期間'] ? 'disabled_input' : ''}`"
                                    :style="{
                                        'background-color':
                                            isNotCheckBoxPartner || isDisabled || !SWITCH_FIELD_TAB_7(dataObject)['抽選対象期間'] ? '' : '#ffffff',
                                        'min-height': '37px'
                                    }"
                                >
                                    {{ formatDateTimeJapanese(detailBeginForDocument.campaign_start_date) }}～{{
                                        formatDateTimeJapanese(detailBeginForDocument.campaign_end_date)
                                    }}
                                </div>
                            </td>
                            <td>
                                <CommonCheckbox
                                    :disabled="isNotCheckBoxPartner || (processingFields && processingFields.period_conditions_lottery_first)"
                                    v-model="dataObject.period_conditions_lottery.first_check"
                                    :currentUser="currentUser"
                                    @input="handleCheckBoxValue('period_conditions_lottery', 'first')"
                                />
                            </td>
                            <td>
                                <CommonCheckbox
                                    :disabled="isNotCheckBoxPartner || (processingFields && processingFields.period_conditions_lottery_secondary)"
                                    v-model="dataObject.period_conditions_lottery.secondary_check"
                                    :currentUser="currentUser"
                                    @input="handleCheckBoxValue('period_conditions_lottery', 'secondary')"
                                />
                            </td>
                        </template>
                    </tr>
                    <tr v-if="SWITCH_FIELD_TAB_7(dataObject, isPreview)['消印有効日（ハガキ）'] && !checkPlatFomTab(['WEB'])">
                        <td class="bg-color5">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_7(dataObject)['消印有効日（ハガキ）']"
                                    :disabled="!SWITCH_FIELD_TAB_7(dataObject)['■期間条件']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            period_conditions_postcard: dataObject.period_conditions_postcard
                                        })
                                    "
                                />
                                消印有効日（ハガキ）
                            </div>
                        </td>
                        <td colspan="5">
                            <div class="d-flex align-items-center mb-2">
                                <DateNormal
                                    :full_date.sync="dataObject.period_conditions_postcard.data"
                                    :disabled="isDisabled || !SWITCH_FIELD_TAB_7(dataObject)['消印有効日（ハガキ）']"
                                >
                                </DateNormal>
                                から
                            </div>
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.period_conditions_postcard_first)"
                                v-model="dataObject.period_conditions_postcard.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('period_conditions_postcard', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.period_conditions_postcard_secondary)"
                                v-model="dataObject.period_conditions_postcard.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('period_conditions_postcard', 'secondary')"
                            />
                        </td>
                    </tr>
                </template>

                <tr v-if="SWITCH_FIELD_TAB_7(dataObject, isPreview)['抽選方法']">
                    <td colspan="2" class="bg-color5">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_7(dataObject)['抽選方法']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        lottery_method: dataObject.lottery_method
                                    })
                                "
                            />
                            抽選方法
                        </div>
                    </td>
                    <td colspan="5">
                        <div
                            :class="`box--text__disabled ${isNotCheckBoxPartner || isDisabled || !SWITCH_FIELD_TAB_7(dataObject)['抽選方法'] ? 'disabled_input' : ''}`"
                            :style="{
                                'background-color':
                                    isNotCheckBoxPartner || isDisabled || !SWITCH_FIELD_TAB_7(dataObject)['抽選方法'] ? '' : '#ffffff',
                                'min-height': '37px'
                            }"
                        >
                            {{ dataObject.lottery_method.data }}
                        </div>
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.lottery_method_first)"
                            v-model="dataObject.lottery_method.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('lottery_method', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.lottery_method_secondary)"
                            v-model="dataObject.lottery_method.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('lottery_method', 'secondary')"
                        />
                    </td>
                </tr>

                <template v-if="SWITCH_FIELD_TAB_7(dataObject, isPreview)['当選条件']">
                    <tr>
                        <td class="bg-color5" colspan="2" rowspan="2">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_7(dataObject)['当選条件']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            winning_conditions: dataObject.winning_conditions,
                                            winning_condition_detail: dataObject.winning_condition_detail
                                        })
                                    "
                                />
                                当選条件
                            </div>
                        </td>
                        <td colspan="5">
                            <CommonMultiselect
                                v-model="dataObject.winning_conditions.data"
                                :options.sync="option.winning_conditions"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_7(dataObject)['当選条件']"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.winning_conditions_first)"
                                v-model="dataObject.winning_conditions.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('winning_conditions', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.winning_conditions_secondary)"
                                v-model="dataObject.winning_conditions.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('winning_conditions', 'secondary')"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colspan="5">
                            <TextareaComponent
                                id="tab7-textarea-1"
                                :model.sync="dataObject.winning_condition_detail.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_7(dataObject)['当選条件']"
                                :isPreview="isPreview"
                                :config="inputConfig.winning_condition_detail"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.winning_condition_detail_first)"
                                v-model="dataObject.winning_condition_detail.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('winning_condition_detail', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.winning_condition_detail_secondary)"
                                v-model="dataObject.winning_condition_detail.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('winning_condition_detail', 'secondary')"
                            />
                        </td>
                    </tr>
                </template>

                <template v-if="SWITCH_FIELD_TAB_7(dataObject, isPreview)['重複条件']">
                    <tr>
                        <td class="bg-color5" rowspan="1">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_7(dataObject)['重複条件']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            prize_overlap: dataObject.prize_overlap
                                        })
                                    "
                                />
                                重複条件
                            </div>
                        </td>
                        <td class="bg-color5">賞品またぎ重複</td>
                        <td colspan="5">
                            <CommonMultiselect
                                v-model="dataObject.prize_overlap.data"
                                :options.sync="option.prize_overlap"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_7(dataObject)['重複条件']"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.prize_overlap_first)"
                                v-model="dataObject.prize_overlap.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('prize_overlap', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.prize_overlap_secondary)"
                                v-model="dataObject.prize_overlap.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('prize_overlap', 'secondary')"
                            />
                        </td>
                    </tr>
                </template>

                <template v-if="SWITCH_FIELD_TAB_7(dataObject, isPreview)['比率指定有無']">
                    <tr>
                        <td class="bg-color5" rowspan="3" colspan="2">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_7(dataObject)['比率指定有無']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            ratio_specification_1: dataObject.ratio_specification_1,
                                            ratio_specification_2: dataObject.ratio_specification_2,
                                            ratio_specification_3: dataObject.ratio_specification_3
                                        })
                                    "
                                />
                                比率指定有無
                            </div>
                        </td>
                        <td colspan="5">
                            <CommonMultiselect
                                v-model="dataObject.ratio_specification_1.data"
                                :options.sync="option.ratio_specification_1"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_7(dataObject)['比率指定有無']"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.ratio_specification_1_first)"
                                v-model="dataObject.ratio_specification_1.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('ratio_specification_1', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.ratio_specification_1_secondary)"
                                v-model="dataObject.ratio_specification_1.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('ratio_specification_1', 'secondary')"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colspan="5">
                            <CommonMultiselect
                                v-model="dataObject.ratio_specification_2.data"
                                :options.sync="option.ratio_specification_2"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_7(dataObject)['比率指定有無']"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.ratio_specification_2_first)"
                                v-model="dataObject.ratio_specification_2.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('ratio_specification_2', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.ratio_specification_2_secondary)"
                                v-model="dataObject.ratio_specification_2.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('ratio_specification_2', 'secondary')"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colspan="5">
                            <TextareaComponent
                                id="tab7-textarea-2"
                                :model.sync="dataObject.ratio_specification_3.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_7(dataObject)['比率指定有無']"
                                :isPreview="isPreview"
                                :config="inputConfig.ratio_specification_3"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.ratio_specification_3_first)"
                                v-model="dataObject.ratio_specification_3.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('ratio_specification_3', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.ratio_specification_3_secondary)"
                                v-model="dataObject.ratio_specification_3.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('ratio_specification_3', 'secondary')"
                            />
                        </td>
                    </tr>
                </template>

                <tr v-if="SWITCH_FIELD_TAB_7(dataObject, isPreview)['クイズ回答内容確認']">
                    <td class="bg-color5" colspan="2">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_7(dataObject)['クイズ回答内容確認']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        confirm_quiz_answer_details: dataObject.confirm_quiz_answer_details
                                    })
                                "
                            />
                            クイズ回答内容確認
                        </div>
                    </td>
                    <td colspan="5">
                        <TextareaComponent
                            id="tab7-textarea-3"
                            :model.sync="dataObject.confirm_quiz_answer_details.data"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_7(dataObject)['クイズ回答内容確認']"
                            :isPreview="isPreview"
                            :config="inputConfig.confirm_quiz_answer_details"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.confirm_quiz_answer_details_first)"
                            v-model="dataObject.confirm_quiz_answer_details.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('confirm_quiz_answer_details', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.confirm_quiz_answer_details_secondary)"
                            v-model="dataObject.confirm_quiz_answer_details.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('confirm_quiz_answer_details', 'secondary')"
                        />
                    </td>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_7(dataObject, isPreview)['その他アンケート条件など']">
                    <td class="bg-color5" colspan="2">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_7(dataObject)['その他アンケート条件など']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        other_survey_conditions_etc: dataObject.other_survey_conditions_etc
                                    })
                                "
                            />
                            その他アンケート条件など
                        </div>
                    </td>
                    <td colspan="5">
                        <TextareaComponent
                            id="tab7-textarea-4"
                            :model.sync="dataObject.other_survey_conditions_etc.data"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_7(dataObject)['その他アンケート条件など']"
                            :isPreview="isPreview"
                            :config="inputConfig.other_survey_conditions_etc"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.other_survey_conditions_etc_first)"
                            v-model="dataObject.other_survey_conditions_etc.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('other_survey_conditions_etc', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.other_survey_conditions_etc_secondary)"
                            v-model="dataObject.other_survey_conditions_etc.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('other_survey_conditions_etc', 'secondary')"
                        />
                    </td>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_7(dataObject, isPreview)['その他条件']">
                    <td class="bg-color5" colspan="2">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_7(dataObject)['その他条件']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        other_conditions: dataObject.other_conditions
                                    })
                                "
                            />
                            その他条件
                        </div>
                    </td>
                    <td colspan="5">
                        <TextareaComponent
                            id="tab7-textarea-5"
                            :model.sync="dataObject.other_conditions.data"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_7(dataObject)['その他条件']"
                            :isPreview="isPreview"
                            :config="inputConfig.other_conditions"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.other_conditions_first)"
                            v-model="dataObject.other_conditions.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('other_conditions', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.other_conditions_secondary)"
                            v-model="dataObject.other_conditions.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('other_conditions', 'secondary')"
                        />
                    </td>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_7(dataObject, isPreview)['＜抽選条件＞その他先_7']">
                    <td class="bg-color5" colspan="2">
                        <b-form-checkbox
                            v-if="!isPreview && !isRolePartner"
                            class="mb-1"
                            switch
                            v-model="SWITCH_FIELD_TAB_7(dataObject)['＜抽選条件＞その他先_7']"
                            @change="toggleCommonSwitch($event, { free_block_lottery_condition: dataObject.free_block_lottery_condition })"
                        />
                        <b-form-input
                            v-model="dataObject.free_block_lottery_condition.title"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_7(dataObject)['＜抽選条件＞その他先_7']"
                            :class="`${isDisabled || !SWITCH_FIELD_TAB_7(dataObject)['＜抽選条件＞その他先_7'] ? 'disabled_cursor' : ''} w-100`"
                        ></b-form-input>
                    </td>
                    <td colspan="5">
                        <div
                            v-if="isNotCheckBoxPartner || isDisabled"
                            class="box--text__disabled"
                            v-html="dataObject.free_block_lottery_condition.data"
                        ></div>
                        <Editor
                            v-else
                            :id="`editor-＜抽選条件＞その他先_7-${idTab}`"
                            :model.sync="dataObject.free_block_lottery_condition.data"
                            :configInit="{
                                disabled: forceEnableEditors ? false : isDisabled || !SWITCH_FIELD_TAB_7(dataObject)['＜抽選条件＞その他先_7'],
                                is_autoresize_on: true
                            }"
                        />
                    </td>
                </tr>

                <tr>
                    <th :colspan="lengthHeaders">＜重複チェック＞</th>
                </tr>
                <template v-if="check1 && SWITCH_FIELD_TAB_7(dataObject, isPreview)['同一世帯']">
                    <tr>
                        <td
                            class="bg-color6"
                            :rowspan="calculateRowspan(SWITCH_FIELD_TAB_7(dataObject, isPreview), CONFIG_ROWSPAN_TAB_7['同一世帯'])"
                        >
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_7(dataObject)['同一世帯']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            same_household_1: dataObject.same_household_1,
                                            same_household_2: dataObject.same_household_2
                                        })
                                    "
                                />
                                同一世帯
                            </div>
                        </td>
                        <template v-if="SWITCH_FIELD_TAB_7(dataObject, isPreview)['確認項目_7_check1']">
                            <td class="bg-color6">
                                <div class="d-flex flex-wrap align-items-center">
                                    <b-form-checkbox
                                        v-if="!isPreview && !isRolePartner"
                                        switch
                                        v-model="SWITCH_FIELD_TAB_7(dataObject)['確認項目_7_check1']"
                                        :disabled="!SWITCH_FIELD_TAB_7(dataObject)['同一世帯']"
                                        @change="
                                            toggleCommonSwitch($event, {
                                                same_household_1: dataObject.same_household_1
                                            })
                                        "
                                    />
                                    確認項目
                                </div>
                            </td>
                            <td colspan="5">
                                <TextareaComponent
                                    id="tab7-textarea-6"
                                    :model.sync="dataObject.same_household_1.data"
                                    :disabled="isDisabled || !SWITCH_FIELD_TAB_7(dataObject)['確認項目_7_check1']"
                                    :isPreview="isPreview"
                                    :config="inputConfig.same_household_1"
                                />
                            </td>
                            <td>
                                <CommonCheckbox
                                    :disabled="isNotCheckBoxPartner || (processingFields && processingFields.same_household_1_first)"
                                    v-model="dataObject.same_household_1.first_check"
                                    :currentUser="currentUser"
                                    @input="handleCheckBoxValue('same_household_1', 'first')"
                                />
                            </td>
                            <td>
                                <CommonCheckbox
                                    :disabled="isNotCheckBoxPartner || (processingFields && processingFields.same_household_1_secondary)"
                                    v-model="dataObject.same_household_1.secondary_check"
                                    :currentUser="currentUser"
                                    @input="handleCheckBoxValue('same_household_1', 'secondary')"
                                />
                            </td>
                        </template>
                    </tr>
                    <tr v-if="SWITCH_FIELD_TAB_7(dataObject, isPreview)['確認条件_7_check1']">
                        <td class="bg-color6">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_7(dataObject)['確認条件_7_check1']"
                                    :disabled="!SWITCH_FIELD_TAB_7(dataObject)['同一世帯']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            same_household_2: dataObject.same_household_2
                                        })
                                    "
                                />
                                確認条件
                            </div>
                        </td>
                        <td colspan="5">
                            <CommonMultiselect
                                v-model="dataObject.same_household_2.data"
                                :options.sync="option.same_household_2"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_7(dataObject)['確認条件_7_check1']"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.same_household_2_first)"
                                v-model="dataObject.same_household_2.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('same_household_2', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.same_household_2_secondary)"
                                v-model="dataObject.same_household_2.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('same_household_2', 'secondary')"
                            />
                        </td>
                    </tr>
                </template>

                <template v-if="check2 && SWITCH_FIELD_TAB_7(dataObject, isPreview)['同一人物']">
                    <tr>
                        <td
                            class="bg-color6"
                            :rowspan="calculateRowspan(SWITCH_FIELD_TAB_7(dataObject, isPreview), CONFIG_ROWSPAN_TAB_7['同一人物'])"
                        >
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_7(dataObject)['同一人物']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            same_person_1: dataObject.same_person_1,
                                            same_person_2: dataObject.same_person_2
                                        })
                                    "
                                />
                                同一人物
                            </div>
                        </td>
                        <template v-if="SWITCH_FIELD_TAB_7(dataObject, isPreview)['確認項目_7_check2']">
                            <td class="bg-color6">
                                <div class="d-flex flex-wrap align-items-center">
                                    <b-form-checkbox
                                        v-if="!isPreview && !isRolePartner"
                                        switch
                                        v-model="SWITCH_FIELD_TAB_7(dataObject)['確認項目_7_check2']"
                                        :disabled="!SWITCH_FIELD_TAB_7(dataObject)['同一人物']"
                                        @change="
                                            toggleCommonSwitch($event, {
                                                same_person_1: dataObject.same_person_1
                                            })
                                        "
                                    />
                                    確認項目
                                </div>
                            </td>
                            <td colspan="5">
                                <TextareaComponent
                                    id="tab7-textarea-7"
                                    :model.sync="dataObject.same_person_1.data"
                                    :disabled="isDisabled || !SWITCH_FIELD_TAB_7(dataObject)['確認項目_7_check2']"
                                    :isPreview="isPreview"
                                    :config="inputConfig.same_person_1"
                                />
                            </td>
                            <td>
                                <CommonCheckbox
                                    :disabled="isNotCheckBoxPartner || (processingFields && processingFields.same_person_1_first)"
                                    v-model="dataObject.same_person_1.first_check"
                                    :currentUser="currentUser"
                                    @input="handleCheckBoxValue('same_person_1', 'first')"
                                />
                            </td>
                            <td>
                                <CommonCheckbox
                                    :disabled="isNotCheckBoxPartner || (processingFields && processingFields.same_person_1_secondary)"
                                    v-model="dataObject.same_person_1.secondary_check"
                                    :currentUser="currentUser"
                                    @input="handleCheckBoxValue('same_person_1', 'secondary')"
                                />
                            </td>
                        </template>
                    </tr>
                    <tr v-if="SWITCH_FIELD_TAB_7(dataObject, isPreview)['確認条件_7_check2']">
                        <td class="bg-color6">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_7(dataObject)['確認条件_7_check2']"
                                    :disabled="!SWITCH_FIELD_TAB_7(dataObject)['同一人物']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            same_person_2: dataObject.same_person_2
                                        })
                                    "
                                />
                                確認条件
                            </div>
                        </td>
                        <td colspan="5">
                            <CommonMultiselect
                                v-model="dataObject.same_person_2.data"
                                :options.sync="option.same_person_2"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_7(dataObject)['確認条件_7_check2']"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.same_person_2_first)"
                                v-model="dataObject.same_person_2.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('same_person_2', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.same_person_2_secondary)"
                                v-model="dataObject.same_person_2.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('same_person_2', 'secondary')"
                            />
                        </td>
                    </tr>
                </template>

                <template v-if="check3 && SWITCH_FIELD_TAB_7(dataObject, isPreview)['＜重複チェック＞その他']">
                    <tr>
                        <td
                            class="bg-color6"
                            :rowspan="calculateRowspan(SWITCH_FIELD_TAB_7(dataObject, isPreview), CONFIG_ROWSPAN_TAB_7['＜重複チェック＞その他'])"
                        >
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_7(dataObject)['＜重複チェック＞その他']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            others_duplicate_1: dataObject.others_duplicate_1,
                                            others_duplicate_2: dataObject.others_duplicate_2
                                        })
                                    "
                                />
                                その他
                            </div>
                        </td>
                        <template v-if="SWITCH_FIELD_TAB_7(dataObject, isPreview)['確認項目_7_check3']">
                            <td class="bg-color6">
                                <div class="d-flex flex-wrap align-items-center">
                                    <b-form-checkbox
                                        v-if="!isPreview && !isRolePartner"
                                        switch
                                        v-model="SWITCH_FIELD_TAB_7(dataObject)['確認項目_7_check3']"
                                        :disabled="!SWITCH_FIELD_TAB_7(dataObject)['＜重複チェック＞その他']"
                                        @change="
                                            toggleCommonSwitch($event, {
                                                others_duplicate_1: dataObject.others_duplicate_1
                                            })
                                        "
                                    />
                                    確認項目
                                </div>
                            </td>
                            <td colspan="5">
                                <TextareaComponent
                                    id="tab7-textarea-8"
                                    :model.sync="dataObject.others_duplicate_1.data"
                                    :disabled="isDisabled || !SWITCH_FIELD_TAB_7(dataObject)['確認項目_7_check3']"
                                    :isPreview="isPreview"
                                    :config="inputConfig.others_duplicate_1"
                                />
                            </td>
                            <td>
                                <CommonCheckbox
                                    :disabled="isNotCheckBoxPartner || (processingFields && processingFields.others_duplicate_1_first)"
                                    v-model="dataObject.others_duplicate_1.first_check"
                                    :currentUser="currentUser"
                                    @input="handleCheckBoxValue('others_duplicate_1', 'first')"
                                />
                            </td>
                            <td>
                                <CommonCheckbox
                                    :disabled="isNotCheckBoxPartner || (processingFields && processingFields.others_duplicate_1_secondary)"
                                    v-model="dataObject.others_duplicate_1.secondary_check"
                                    :currentUser="currentUser"
                                    @input="handleCheckBoxValue('others_duplicate_1', 'secondary')"
                                />
                            </td>
                        </template>
                    </tr>
                    <tr v-if="SWITCH_FIELD_TAB_7(dataObject, isPreview)['確認条件_7_check3']">
                        <td class="bg-color6">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_7(dataObject)['確認条件_7_check3']"
                                    :disabled="!SWITCH_FIELD_TAB_7(dataObject)['＜重複チェック＞その他']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            others_duplicate_2: dataObject.others_duplicate_2
                                        })
                                    "
                                />
                                確認条件
                            </div>
                        </td>
                        <td colspan="5">
                            <CommonMultiselect
                                v-model="dataObject.others_duplicate_2.data"
                                :options.sync="option.others_duplicate_2"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_7(dataObject)['確認条件_7_check3']"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.others_duplicate_2_first)"
                                v-model="dataObject.others_duplicate_2.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('others_duplicate_2', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.others_duplicate_2_secondary)"
                                v-model="dataObject.others_duplicate_2.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('others_duplicate_2', 'secondary')"
                            />
                        </td>
                    </tr>
                </template>

                <template v-if="check4 && SWITCH_FIELD_TAB_7(dataObject, isPreview)['固有ID']">
                    <tr>
                        <td class="bg-color6" :rowspan="calculateRowspan(SWITCH_FIELD_TAB_7(dataObject, isPreview), CONFIG_ROWSPAN_TAB_7['固有ID'])">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_7(dataObject)['固有ID']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            unique_id_1: dataObject.unique_id_1,
                                            unique_id_2: dataObject.unique_id_2
                                        })
                                    "
                                />
                                固有ID
                            </div>
                        </td>
                        <template v-if="SWITCH_FIELD_TAB_7(dataObject, isPreview)['確認項目_7_check4']">
                            <td class="bg-color6">
                                <div class="d-flex flex-wrap align-items-center">
                                    <b-form-checkbox
                                        v-if="!isPreview && !isRolePartner"
                                        switch
                                        v-model="SWITCH_FIELD_TAB_7(dataObject)['確認項目_7_check4']"
                                        :disabled="!SWITCH_FIELD_TAB_7(dataObject)['固有ID']"
                                        @change="
                                            toggleCommonSwitch($event, {
                                                unique_id_1: dataObject.unique_id_1
                                            })
                                        "
                                    />
                                    確認項目
                                </div>
                            </td>
                            <td colspan="5">
                                <TextareaComponent
                                    id="tab7-textarea-9"
                                    :model.sync="dataObject.unique_id_1.data"
                                    :disabled="isDisabled || !SWITCH_FIELD_TAB_7(dataObject)['確認項目_7_check4']"
                                    :isPreview="isPreview"
                                    :config="inputConfig.unique_id_1"
                                />
                            </td>
                            <td>
                                <CommonCheckbox
                                    :disabled="isNotCheckBoxPartner || (processingFields && processingFields.unique_id_1_first)"
                                    v-model="dataObject.unique_id_1.first_check"
                                    :currentUser="currentUser"
                                    @input="handleCheckBoxValue('unique_id_1', 'first')"
                                />
                            </td>
                            <td>
                                <CommonCheckbox
                                    :disabled="isNotCheckBoxPartner || (processingFields && processingFields.unique_id_1_secondary)"
                                    v-model="dataObject.unique_id_1.secondary_check"
                                    :currentUser="currentUser"
                                    @input="handleCheckBoxValue('unique_id_1', 'secondary')"
                                />
                            </td>
                        </template>
                    </tr>
                    <tr v-if="SWITCH_FIELD_TAB_7(dataObject, isPreview)['確認条件_7_check4']">
                        <td class="bg-color6">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_7(dataObject)['確認条件_7_check4']"
                                    :disabled="!SWITCH_FIELD_TAB_7(dataObject)['固有ID']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            unique_id_2: dataObject.unique_id_2
                                        })
                                    "
                                />
                                確認条件
                            </div>
                        </td>
                        <td colspan="5">
                            <CommonMultiselect
                                v-model="dataObject.unique_id_2.data"
                                :options.sync="option.unique_id_2"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_7(dataObject)['確認条件_7_check4']"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.unique_id_2_first)"
                                v-model="dataObject.unique_id_2.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('unique_id_2', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.unique_id_2_secondary)"
                                v-model="dataObject.unique_id_2.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('unique_id_2', 'secondary')"
                            />
                        </td>
                    </tr>
                </template>

                <template v-if="SWITCH_FIELD_TAB_7(dataObject, isPreview)['その他データとの付け合わせ確認']">
                    <tr>
                        <td class="bg-color6" colspan="2" rowspan="2">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_7(dataObject)['その他データとの付け合わせ確認']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            matching_with_other_data_1: dataObject.matching_with_other_data_1,
                                            matching_with_other_data_2: dataObject.matching_with_other_data_2
                                        })
                                    "
                                />
                                その他データとの付け合わせ確認
                            </div>
                        </td>
                        <td colspan="5">
                            <CommonMultiselect
                                v-model="dataObject.matching_with_other_data_1.data"
                                :options.sync="option.matching_with_other_data_1"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_7(dataObject)['その他データとの付け合わせ確認']"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.matching_with_other_data_1_first)"
                                v-model="dataObject.matching_with_other_data_1.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('matching_with_other_data_1', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.matching_with_other_data_1_secondary)"
                                v-model="dataObject.matching_with_other_data_1.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('matching_with_other_data_1', 'secondary')"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colspan="5">
                            <TextareaComponent
                                id="tab7-textarea-10"
                                :model.sync="dataObject.matching_with_other_data_2.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_7(dataObject)['その他データとの付け合わせ確認']"
                                :isPreview="isPreview"
                                :config="inputConfig.matching_with_other_data_2"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.matching_with_other_data_2_first)"
                                v-model="dataObject.matching_with_other_data_2.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('matching_with_other_data_2', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.matching_with_other_data_2_secondary)"
                                v-model="dataObject.matching_with_other_data_2.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('matching_with_other_data_2', 'secondary')"
                            />
                        </td>
                    </tr>
                </template>
                <tr v-if="SWITCH_FIELD_TAB_7(dataObject, isPreview)['＜重複チェック＞その他先_7']">
                    <td class="bg-color6" colspan="2">
                        <b-form-checkbox
                            v-if="!isPreview && !isRolePartner"
                            class="mb-1"
                            switch
                            v-model="SWITCH_FIELD_TAB_7(dataObject)['＜重複チェック＞その他先_7']"
                            @change="toggleCommonSwitch($event, { free_block_duplicate_check: dataObject.free_block_duplicate_check })"
                        />
                        <b-form-input
                            v-model="dataObject.free_block_duplicate_check.title"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_7(dataObject)['＜重複チェック＞その他先_7']"
                            :class="`${isDisabled || !SWITCH_FIELD_TAB_7(dataObject)['＜重複チェック＞その他先_7'] ? 'disabled_cursor' : ''} w-100`"
                        ></b-form-input>
                    </td>
                    <td colspan="5">
                        <div
                            v-if="isNotCheckBoxPartner || isDisabled"
                            class="box--text__disabled"
                            v-html="dataObject.free_block_duplicate_check.data"
                        ></div>
                        <Editor
                            v-else
                            :id="`editor-＜重複チェック＞その他先_7-${idTab}`"
                            :model.sync="dataObject.free_block_duplicate_check.data"
                            :configInit="{
                                disabled: forceEnableEditors ? false : isDisabled || !SWITCH_FIELD_TAB_7(dataObject)['＜重複チェック＞その他先_7'],
                                is_autoresize_on: true
                            }"
                        />
                    </td>
                </tr>

                <tr>
                    <th :colspan="lengthHeaders">＜不備チェック＞</th>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_7(dataObject, isPreview)['名前不備確認']">
                    <td class="bg-color6" colspan="2">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_7(dataObject)['名前不備確認']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        confirm_error_name: dataObject.confirm_error_name
                                    })
                                "
                            />
                            名前不備確認
                        </div>
                    </td>
                    <td colspan="5">
                        <TextareaComponent
                            id="tab7-textarea-11"
                            :model.sync="dataObject.confirm_error_name.data"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_7(dataObject)['名前不備確認']"
                            :isPreview="isPreview"
                            :config="inputConfig.confirm_error_name"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.confirm_error_name_first)"
                            v-model="dataObject.confirm_error_name.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('confirm_error_name', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.confirm_error_name_secondary)"
                            v-model="dataObject.confirm_error_name.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('confirm_error_name', 'secondary')"
                        />
                    </td>
                </tr>

                <template v-if="SWITCH_FIELD_TAB_7(dataObject, isPreview)['住所不備確認']">
                    <tr>
                        <td class="bg-color6" colspan="2" rowspan="2">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_7(dataObject)['住所不備確認']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            address_verification_1: dataObject.address_verification_1,
                                            address_verification_2: dataObject.address_verification_2
                                        })
                                    "
                                />
                                住所不備確認
                            </div>
                        </td>
                        <td colspan="5">
                            <TextareaComponent
                                id="tab7-textarea-12"
                                :model.sync="dataObject.address_verification_1.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_7(dataObject)['住所不備確認']"
                                :isPreview="isPreview"
                                :config="inputConfig.address_verification_1"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.address_verification_1_first)"
                                v-model="dataObject.address_verification_1.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('address_verification_1', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.address_verification_1_secondary)"
                                v-model="dataObject.address_verification_1.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('address_verification_1', 'secondary')"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colspan="5">
                            <CommonMultiselect
                                v-model="dataObject.address_verification_2.data"
                                :options.sync="option.address_verification_2"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_7(dataObject)['住所不備確認']"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.address_verification_2_first)"
                                v-model="dataObject.address_verification_2.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('address_verification_2', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.address_verification_2_secondary)"
                                v-model="dataObject.address_verification_2.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('address_verification_2', 'secondary')"
                            />
                        </td>
                    </tr>
                </template>
                <tr v-if="SWITCH_FIELD_TAB_7(dataObject, isPreview)['電話番号不備確認']">
                    <td class="bg-color6" colspan="2">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_7(dataObject)['電話番号不備確認']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        confirm_phone_number_is_incomplete: dataObject.confirm_phone_number_is_incomplete
                                    })
                                "
                            />
                            電話番号不備確認
                        </div>
                    </td>
                    <td colspan="5">
                        <TextareaComponent
                            id="tab7-textarea-13"
                            :model.sync="dataObject.confirm_phone_number_is_incomplete.data"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_7(dataObject)['電話番号不備確認']"
                            :isPreview="isPreview"
                            :config="inputConfig.confirm_phone_number_is_incomplete"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.confirm_phone_number_is_incomplete_first)"
                            v-model="dataObject.confirm_phone_number_is_incomplete.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('confirm_phone_number_is_incomplete', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.confirm_phone_number_is_incomplete_secondary)"
                            v-model="dataObject.confirm_phone_number_is_incomplete.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('confirm_phone_number_is_incomplete', 'secondary')"
                        />
                    </td>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_7(dataObject, isPreview)['メールアドレス不備確認']">
                    <td class="bg-color6" colspan="2">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_7(dataObject)['メールアドレス不備確認']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        confirm_email_address_is_incomplete: dataObject.confirm_email_address_is_incomplete
                                    })
                                "
                            />
                            メールアドレス不備確認
                        </div>
                    </td>
                    <td colspan="5">
                        <TextareaComponent
                            id="tab7-textarea-14"
                            :model.sync="dataObject.confirm_email_address_is_incomplete.data"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_7(dataObject)['メールアドレス不備確認']"
                            :isPreview="isPreview"
                            :config="inputConfig.confirm_email_address_is_incomplete"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.confirm_email_address_is_incomplete_first)"
                            v-model="dataObject.confirm_email_address_is_incomplete.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('confirm_email_address_is_incomplete', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.confirm_email_address_is_incomplete_secondary)"
                            v-model="dataObject.confirm_email_address_is_incomplete.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('confirm_email_address_is_incomplete', 'secondary')"
                        />
                    </td>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_7(dataObject, isPreview)['＜不備チェック＞その他']">
                    <td class="bg-color6" colspan="2">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_7(dataObject)['＜不備チェック＞その他']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        other_errors: dataObject.other_errors
                                    })
                                "
                            />
                            その他
                        </div>
                    </td>
                    <td colspan="5">
                        <TextareaComponent
                            id="tab7-textarea-15"
                            :model.sync="dataObject.other_errors.data"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_7(dataObject)['＜不備チェック＞その他']"
                            :isPreview="isPreview"
                            :config="inputConfig.other_errors"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.other_errors_first)"
                            v-model="dataObject.other_errors.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('other_errors', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.other_errors_secondary)"
                            v-model="dataObject.other_errors.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('other_errors', 'secondary')"
                        />
                    </td>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_7(dataObject, isPreview)['フリーブロックその他先']">
                    <td class="bg-color6" colspan="2">
                        <b-form-checkbox
                            v-if="!isPreview && !isRolePartner"
                            class="mb-1"
                            switch
                            v-model="SWITCH_FIELD_TAB_7(dataObject)['フリーブロックその他先']"
                            @change="toggleCommonSwitch($event, { free_block_other: dataObject.free_block_other })"
                        />
                        <b-form-input
                            v-model="dataObject.free_block_other.title"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_7(dataObject)['フリーブロックその他先']"
                            :class="`${isDisabled || !SWITCH_FIELD_TAB_7(dataObject)['フリーブロックその他先'] ? 'disabled_cursor' : ''} w-100`"
                        ></b-form-input>
                    </td>
                    <td colspan="5">
                        <div v-if="isNotCheckBoxPartner || isDisabled" class="box--text__disabled" v-html="dataObject.free_block_other.data"></div>
                        <Editor
                            v-else
                            :id="`editor-${idTab}`"
                            :model.sync="dataObject.free_block_other.data"
                            :configInit="{
                                disabled: forceEnableEditors ? false : isDisabled || !SWITCH_FIELD_TAB_7(dataObject)['フリーブロックその他先'],
                                is_autoresize_on: true
                            }"
                        />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import CommonMultiselect from './CommonMultiselect.vue';
import DateNormal from '@/components/DateCustoms/DateNormal/main.vue';
import CommonCheckbox from '@/views/pages/require/components/CommonCheckbox.vue';
import TextareaComponent from '@/components/Textarea/main.vue';
import Editor from '@/components/Editor/main.vue';
import editorDelayMixin from '@/mixins/editorDelayMixin';

import { InputText } from '@/components/Input';
import { STR_DATE } from '@/utils/format';
import {
    formatDateTimeJapanese,
    toggleCommonSwitch,
    isRolePartner,
    onHandleDataCheckValueForPartner,
    calculateRowspan,
    checkPlatFomTab
} from '@/views/pages/require/handlers';
import { CONFIG_TABLE_TAB_7 } from '@/views/pages/require/constant-table';
import { SWITCH_FIELD_TAB_7, configHelperOptions, CONFIG_INPUT_TAB_7, CONFIG_ROWSPAN_TAB_7 } from '@/views/pages/require/const-field-tab';

export default {
    name: 'Tab7Require',
    mixins: [editorDelayMixin],
    props: {
        isNotCheckBoxPartner: {
            type: Boolean,
            default: () => false
        },
        keyTab: {
            type: [String],
            default: ''
        },
        idTab: {
            type: [String, Number],
            default: ''
        },
        dataObject: {
            type: Object,
            required: false
        },
        check1: {
            type: Boolean,
            required: false
        },
        check2: {
            type: Boolean,
            required: false
        },
        check3: {
            type: Boolean,
            required: false
        },
        check4: {
            type: Boolean,
            required: false
        },
        currentUser: {
            type: Object,
            required: false
        },
        detailBeginForDocument: {
            type: Object,
            required: false
        },
        isDisabled: {
            type: Boolean,
            required: false
        },
        isPreview: {
            type: Boolean,
            required: false
        },
        processingFields: {
            type: Object,
            default: () => ({})
        }
    },
    components: {
        CommonMultiselect,
        DateNormal,
        CommonCheckbox,
        InputText,
        TextareaComponent,
        Editor
    },
    computed: {
        lengthHeaders() {
            return CONFIG_TABLE_TAB_7().headers.reduce((acc, col) => acc + (col.colspan || 1), 0);
        },
        CONFIG_ROWSPAN_TAB_7() {
            const config = JSON.parse(JSON.stringify(CONFIG_ROWSPAN_TAB_7));
            if (this.checkPlatFomTab(['WEB'])) {
                config['■期間条件'] = { base: 1, fields: {} };
            }
            return config;
        },
        option() {
            const option = JSON.parse(JSON.stringify(configHelperOptions.optionTab7));
            if (this.checkPlatFomTab(['ハガキ']) || this.checkPlatFomTab(['WEB'])) {
                option.target_file = configHelperOptions.optionPostcard;
            }
            return option;
        }
    },
    data() {
        return {
            customFormatDate: STR_DATE,
            isRolePartner: isRolePartner(),
            inputConfig: CONFIG_INPUT_TAB_7()
        };
    },
    methods: {
        formatDateTimeJapanese,
        CONFIG_TABLE_TAB_7,
        toggleCommonSwitch,
        SWITCH_FIELD_TAB_7,
        calculateRowspan,

        handleCheckBoxValue(fieldName, type, index) {
            const payload = onHandleDataCheckValueForPartner(this.keyTab, this.dataObject, fieldName);
            this.$emit('handleTabCheckBoxValue', { payload, fieldName, type, index });
        },

        checkPlatFomTab(label) {
            return checkPlatFomTab(this.detailBeginForDocument.categories, label);
        }
    },
    watch: {
        dataObject: function () {},
        'option.target_file': {
            handler(newList) {
                if (this.dataObject?.target_file?.data && Array.isArray(this.dataObject.target_file.data)) {
                    this.dataObject.target_file.data = this.dataObject.target_file.data.filter((item) => newList.includes(item));
                }
            },
            immediate: true
        }
    }
};
</script>

<style lang="scss" scoped>
.box8 input[type='text'] {
    width: 200px;
}

.box8 textarea.form-control {
    //width: 400px;
}
</style>
